import { getSessionStorageItem } from 'libs/utils/src/lib/storage/sessionStorage';

/**
 * Checks if a country-specific banner is currently active
 * @returns boolean indicating if country banner is active
 */
export const isCountryBannerActive = (): boolean => {
  return getSessionStorageItem('isCountySpecificBanner') === 'true';
};
